import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const HalfCircleRightIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    sx={{ width: 38, height: 38 }}
    {...props}
  >
    <path
      d="M38 38L19 38C8.50659 38 7.4367e-07 29.4934 1.66103e-06 19C2.5784e-06 8.50659 8.50659 7.4367e-07 19 1.66103e-06L38 3.32207e-06L38 38Z"
      fill="white"
    />
    <path
      d="M17.5236 29.9139C16.9326 29.9139 16.3999 29.558 16.1738 29.012C15.9476 28.4661 16.0726 27.8377 16.4905 27.4199L24.4107 19.5001L16.4905 11.5802C15.9199 11.0097 15.9199 10.0846 16.4905 9.51406C17.061 8.94351 17.9861 8.94351 18.5566 9.51406L27.5096 18.467C27.7836 18.741 27.9375 19.1126 27.9375 19.5001C27.9375 19.8875 27.7836 20.2591 27.5096 20.5331L18.5566 29.486C18.2829 29.7604 17.9111 29.9144 17.5236 29.9139Z"
      fill="#000D8C"
    />
  </SvgIcon>
);

export default HalfCircleRightIcon;
